module.exports = "\n<aps-spinner></aps-spinner>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /var/www/angular/mobilit-web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main